module.exports = __webpack_public_path__ + "static/media/appointment_requested.208638b4.svg";